import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { reactPlugin } from "./utils/appInsights";
import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";

// Custom Components
import GlobalContextProviders from './GlobalContextProviders';

// We define the setup of our app here
function App() {
  return (
    <BrowserRouter basename='/app'>
      <AppInsightsErrorBoundary onError={(error: Error) => <p></p> }  appInsights={reactPlugin}>
        {/* The routes are inside of RouteConfiguration which is inside of GlobalContextProviders */}
        <GlobalContextProviders />
      </AppInsightsErrorBoundary>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
